/* global axios */
import ApiClient from './ApiClient';

class FlowBuilderAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  activate(flowId) {
    return axios.post(`${this.url}/${flowId}/activate`);
  }

  deactivate(flowId) {
    return axios.post(`${this.url}/${flowId}/deactivate`);
  }

  clone(flowId) {
    return axios.post(`${this.url}/${flowId}/clone`);
  }

  getExecutions(flowId) {
    return axios.get(`${this.url}/${flowId}/flow_executions`);
  }

  simulate(flowId, payload) {
    return axios.post(`${this.url}/${flowId}/simulate`, payload);
  }
}

export default new FlowBuilderAPI();
